import { render, staticRenderFns } from "./Spouse.vue?vue&type=template&id=f1b03268&scoped=true&"
import script from "./Spouse.vue?vue&type=script&lang=js&"
export * from "./Spouse.vue?vue&type=script&lang=js&"
import style0 from "./Spouse.vue?vue&type=style&index=0&id=f1b03268&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b03268",
  null
  
)

export default component.exports